export default __webpack_public_path__ + "static/media/TransactionReport.fbaf4f14.png";